// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const adminGatePassed = localStorage.getItem("adminGate") === "passed";

  if (!adminGatePassed) {
    // Redirect to the admin gate page if not verified
    return <Navigate to="/admin-gate" replace />;
  }

  return children;
}

export default ProtectedRoute;
